import { MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useWhatsAppUnread } from "@/hooks/use-whatsapp";

/**
 * The top bar's way into the inbox, with how many chats have unread messages.
 * The count comes from the live loop; the app shell renders this only with
 * `whatsapp.view`.
 */
export function WhatsAppTopbarButton() {
  const unread = useWhatsAppUnread();
  const count = unread?.threads ?? 0;
  const label =
    count > 0
      ? `WhatsApp — ${count} ${count === 1 ? "chat" : "chats"} with unread messages`
      : "WhatsApp";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="icon-sm" asChild className="relative">
          <Link to="/whatsapp" aria-label={label}>
            <MessageCircle aria-hidden="true" />
            {count > 0 ? (
              <span
                aria-hidden="true"
                className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-destructive px-1 text-xs font-semibold tabular-nums leading-none text-destructive-foreground"
              >
                {count > 99 ? "99+" : count}
              </span>
            ) : null}
          </Link>
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
